var __assign = this && this.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, { useState } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import './detailStep.less';
import {
    Button,
    Dragger,
    Form,
    Loader,
    TextArea
} from 'oned';
import { DetailsBusiness } from '@business/newCreateRequest/stepsItems/detail';
import { createForm } from 'rc-form';
import {
    AmplitudeEventName,
    ProblemLevel
} from '@common/enums/base';
import classnames from 'classnames';
import {
    getCurrentEnv,
    sendAmplitude_Default
} from '@common/utils';
import DuplicateOriginWODom from '../problem/duplicateCheck/OriginWO';
import RecallOriginWODom from '../problem/recallCheck/originWO';
import Cookies from 'js-cookie';
var DifferentIssue = ProblemLevel.DifferentIssue, DuplicateOriginWO = ProblemLevel.DuplicateOriginWO, RecallOriginWO = ProblemLevel.RecallOriginWO;
var FormItem = Form.FormItem;
var additionalDetailPlaceholder = 'More information on what\'s happening. Write about sounds, smells, or details that will help the technician prepare\u2026';
var StepsDetails = inject(DetailsBusiness)(observer(function (props) {
    var next = props.next, problemCaseCadeName = props.problemCaseCadeName, setAdditionalDetail = props.setAdditionalDetail, form = props.form, getDetailNextButtonDisable = props.getDetailNextButtonDisable, attachmentList = props.attachmentList, deleteAttachment = props.deleteAttachment, currentIconUrl = props.currentIconUrl, additionalDetail = props.additionalDetail, currentUser = props.currentUser, isAliasingView = props.isAliasingView, level = props.level;
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var getFieldError = form.getFieldError;
    var getError = function (field) {
        var error = getFieldError(field);
        return error ? error.join(',') : '';
    };
    var uploadEvent = function (files) {
        var uploadAttachment = props.uploadAttachment;
        setLoading(true);
        var uploadCount = 0;
        var uploadFailCount = 0;
        return new Promise(function (resolve) {
            if (!files.length) {
                resolve(true);
                setLoading(false);
            }
            if (files.length <= 10) {
                files.forEach(function (file, index) {
                    uploadAttachment(file).then(function (data) {
                        uploadCount++;
                        if (!data) {
                            ++uploadFailCount;
                        }
                        if (uploadFailCount === files.length) {
                            resolve(false);
                            setLoading(false);
                            showNotification('You have ' + uploadFailCount + ' ' + (uploadFailCount > 1 ? 'files' : 'file') + ' upload error.');
                        } else if (uploadCount === files.length) {
                            resolve(true);
                            setLoading(false);
                            uploadFailCount && showNotification('You have ' + uploadFailCount + ' file upload error.');
                        }
                    });
                });
            } else {
                showNotification('Upload up to 10 attachments at one time.');
                resolve(false);
                setLoading(false);
            }
        });
    };
    var showNotification = function (content) {
        window.notificationManager.show({
            title: 'Something was wrong !',
            type: 'primary',
            position: 'top-right',
            content: content
        });
    };
    var goNextStep = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        form.validateFields()
                    ];
                case 1:
                    _a.sent();
                    sendAmplitude_Default(AmplitudeEventName.NewRSP_Step2to3, {
                        userId: currentUser.userId,
                        residentId: currentUser.residentId,
                        uploadAttachment: attachmentList,
                        clientId: Cookies.get('clientId'),
                        env: getCurrentEnv()
                    });
                    next();
                    return [2];
                }
            });
        });
    };
    return React.createElement(React.Fragment, null, level === DifferentIssue && React.createElement(React.Fragment, null, React.createElement(Loader, {
        page: true,
        visible: loading
    }), React.createElement('div', { className: 'dsm-card rsp-step-details' }, React.createElement('div', { className: 'dsm-card-body' }, React.createElement('div', { className: 'detail-service-combination d-flex align-items-center' }, React.createElement('img', {
        src: currentIconUrl,
        className: 'svc-icon'
    }), React.createElement('span', { className: classnames('detail-svc', isAliasingView && 'ml-4') }, problemCaseCadeName)), React.createElement(React.Fragment, null, React.createElement('p', { className: 'form-item-title mt-4' }, 'Provide us with more details so we can get you the right help'), React.createElement(FormItem, { error: getError('additionalDetail') }, React.createElement(TextArea, __assign({
        placeholder: additionalDetailPlaceholder,
        'data-one-uiautomation': 'rsp-step-details-additionalDetail',
        className: 'additional-detail-input'
    }, form.getFieldProps('additionalDetail', {
        initialValue: additionalDetail,
        onChange: function (e) {
            return setAdditionalDetail(e.target.value);
        },
        rules: [{
                max: 500,
                message: 'Please enter no more than 500 characters.'
            }]
    }))))), React.createElement('div', { className: 'attachment-view' }, React.createElement('p', { className: 'form-item-title mt-5 f22' }, 'Add photo/video attachments'), React.createElement(Dragger, {
        multiple: true,
        fileList: attachmentList,
        onUpload: function (files) {
            return uploadEvent(files);
        },
        onRemove: function (index) {
            return deleteAttachment(index);
        },
        maxSize: 1024 * 1024 * 50,
        accept: '.3gp,.avi,.rmvb,.rm,.mp4,.mov,.m4a,.amr,.mp3,.wav,.wma,.asf,.mpg,.mpeg,.vob,.jpg,.jpeg,.peg,.png,.gif,.bmp,.svg,.heif,.heic,.hevc,.mkv'
    })))), React.createElement(Button, {
        type: 'primary',
        disabled: getDetailNextButtonDisable(),
        className: 'w-100 my-4 dsm-btn-primary dsm-btn',
        onClick: goNextStep
    }, 'Next')), level === DuplicateOriginWO && React.createElement(DuplicateOriginWODom, null), level === RecallOriginWO && React.createElement(RecallOriginWODom, null));
}));
export default createForm()(StepsDetails);